import { makeStyles } from '@material-ui/core';
import React from 'react';
const useSlotListStyles = makeStyles((theme: any) => ({
    filterContainer: {
        marginBottom: 12,
    },
    container: (props: any) => ({
        //overflowY: 'auto',
        //overflowX: 'auto',
        // overflow: 'auto',
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        // },
        // '&::-webkit-scrollbar-track': {
        //     background: '#f1f1f1',
        //     borderRadius: '8px',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     background: '#888',
        //     borderRadius: '8px',
        // },
        // '&::-webkit-scrollbar-thumb:hover': {
        //     background: '#555',
        // },
    }),
    card: {
        backgroundColor: '#f6f7f9',
        marginTop: 16,
        color: '#000',
        padding: 16,
    },
    routeContainer: {
        padding: '12px 12px',
        paddingBottom: 0,
    },
    backIcon: {
        minWidth: '0',
        color: '#000000',
        cursor: 'pointer',
        marginRight: '8px',
    },
    scrollableBox: {
        width: '100%',
        height: '38vh',
        overflowY: 'auto',
        minHeight: '38vh',
        maxHeight: '38vh',
        marginTop: 12,
        borderRadius: 16,
    },
    filterBox: {
        width: 'auto',
        height: 'auto',
        minWidth: 160,
        minHeight: 112,
        boxShadow: 'none',
        padding: '12px 16px',
        border: '1px solid #EBEDF8',
        borderRadius: '4px',
        backgroundColor: '#F6F7F9',
        cursor: 'pointer',
    },
    cardHeader: {
        fontSize: '16px',
        fontWeight: 600,
    },
    cardSubHeader: {
        fontSize: '22px',
        fontWeight: 700,
        marginTop: '16px',
    },
    tableContainer: {
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        paddingRight: '8px',
        minHeight: 'calc(100vh - 364px)',
        maxHeight: 'calc(100vh - 364px)',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
    },
    tableTLContainer: {
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        paddingRight: '8px',
        minHeight: 'calc(100vh - 447px)',
        maxHeight: 'calc(100vh - 447px)',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
    },
    tableValue: {
        wordBreak: 'break-all',
        fontWeight: 700,
        fontSize: 16,
        color: '#14112D',
    },
    tableSubValue: {
        wordBreak: 'break-all',
        fontWeight: 400,
        fontSize: 14,
        marginTop: '6px',
        color: '#14112D',
    },
    tableValueBold: {
        wordBreak: 'break-all',
        fontWeight: 700,
        fontSize: 16,
    },
    chip: {
        fontSize: 12,
        width: 'auto',
        color: ' #fff',
        border: '1px solid #fff',
        borderRadius: '8px',
        padding: '2px 12px',
        //margin: '0px 8px',
        textAlign: 'center',
        backgroundColor: 'black',
    },
    chipText: {
        fontSize: 12,
        color: 'inherit',
    },
    peak: {
        backgroundColor: '#F4EBFC !important',
        border: '1px solid #43419E !important',
        color: '#43419E !important',
    },
    normal: {
        backgroundColor: '#F4EBFC !important',
        border: '1px solid #43419E !important',
        color: '#43419E !important',
    },
    menu: {
        border: '1px solid #3f51b5',
        color: ' #3f51b5',
        borderRadius: 8,
        padding: '8px',
    },
    paginationContainer: {},
    cardCX: {
        borderRadius: 8,
        border: '1px solid #EAEAEA',
        background: '#FFF',
    },
}));
export default useSlotListStyles;
